import React, { useEffect } from 'react';
import data from '../data.json';
import './MapCapitalCities.css';
import { clearMapElements } from '../Map';

const MapCapitalCities: React.FC = () => {
    useEffect(() => {
        const svg = document.getElementById('world-map');
        if (svg) {
            clearMapElements();

            const paths = svg.getElementsByTagName('path');
            Array.from(paths).forEach(path => {
                const countryId = path.id.toUpperCase();
                const countryData = data.find(country => country.i.toUpperCase() === countryId);
                if (countryData && countryData.cc && countryData.cc.length > 0) {
                    const isEurope = countryData.o === 'Europe';
                    const fontSize = isEurope ? 8 : 14;
                    const lineHeight = fontSize * 1.2;

                    const xPosition = path.getBBox().x + path.getBBox().width / 2;
                    const yPosition = path.getBBox().y + path.getBBox().height / 2;

                    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                    text.classList.add('capital-city');
                    text.classList.add('map-element'); // Add this line
                    text.setAttribute('x', xPosition.toString());
                    text.setAttribute('y', yPosition.toString());
                    text.setAttribute('text-anchor', 'middle');
                    text.setAttribute('font-size', fontSize.toString());
                    text.setAttribute('fill', 'black');
                    text.style.fontFamily = 'Inter, sans-serif';
                    text.style.lineHeight = '1.2';

                    countryData.cc.forEach((city, index) => {
                        const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                        tspan.setAttribute('x', xPosition.toString());
                        tspan.setAttribute('dy', index === 0 ? '0' : lineHeight.toString());
                        tspan.textContent = city;
                        text.appendChild(tspan);
                    });

                    svg.appendChild(text);
                }
            });
        }
    }, []);

    return null;
};

export default MapCapitalCities;
